var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.handledError)?_c('div',{staticClass:"container__error"},[_c('div',{staticClass:"fas fa-3x mb-3",class:_vm.handledError.icon}),_c('h3',[_vm._v(" "+_vm._s(_vm.$t(_vm.handledError.title))+" ")]),_c('div',[_vm._v(" "+_vm._s(_vm.$t(_vm.handledError.message))+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }